export default __webpack_public_path__ + "static/media/applications-image-28.809dc8e1.jpg";